import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../../axios/axiosBaseQuery';
import {
  AlarmsQueryAPIResponse,
  AlarmsQueryParamsAPIRequest,
  IncidentAPIResponseMVP,
} from './Incident.model';
import { Base64 } from '../../../util/Base64';
import { cleanObjectWithEmptyString } from '../../../util/CleanUndefined';
import Util from '../../../util/Util';

const AlarmBaseURL = new Util().getAlarmServiceURL();
const IncidentAPI = createApi({
  reducerPath: 'incident',
  baseQuery: axiosBaseQuery({ baseUrl: AlarmBaseURL }),
  tagTypes: [
    'policy-actions',
    'subscription-actions',
    'group-subscription-actions',
    'policy-subscription-actions',
    'incident-actions',
    'device-subscription-actions',
  ],
  endpoints(build) {
    return {
      getIncidentsByPolicyId: build.query<
        IncidentAPIResponseMVP[],
        string | undefined
      >({
        query: (policyId = '') => ({
          url: `/incident?policyId=${policyId}`,
        }),
        providesTags: ['incident-actions'],
      }),
      getIncidentById: build.query<IncidentAPIResponseMVP, string | undefined>({
        query: (incidentId = '') => ({
          url: `/incident/${Base64.encode(incidentId)}`,
        }),
        providesTags: ['incident-actions'],
      }),
      getIncidentByWorkspaceId: build.query<
        IncidentAPIResponseMVP[],
        string | undefined
      >({
        query: (workspaceId = '') => ({
          url: `/workspace/${Base64.encode(workspaceId)}/incident`,
        }),
        providesTags: ['incident-actions'],
      }),
      getMyIncidentByWorkspaceId: build.query<
        IncidentAPIResponseMVP[],
        { workspaceId?: string; filterByActive?: boolean }
      >({
        query: ({ workspaceId = '', filterByActive = true }) => ({
          url: filterByActive
            ? `/workspace/${Base64.encode(workspaceId)}/incident/self/active`
            : `/workspace/${Base64.encode(workspaceId)}/incident/self`,
        }),
        providesTags: ['incident-actions'],
      }),
      queryMyIncidentByWorkspaceId: build.query<
        AlarmsQueryAPIResponse,
        { workspaceId?: string; params?: AlarmsQueryParamsAPIRequest }
      >({
        query: ({ workspaceId = '', params = {} }) => ({
          url: `/workspace/${Base64.encode(workspaceId)}/incident/self/query`,
          params: cleanObjectWithEmptyString(params),
        }),
        providesTags: ['incident-actions'],
      }),
    };
  },
});

// Incident/Policy/api/PolicyAPI.ts inject more endpoints
export default IncidentAPI;
